/** Endpoints #48-#50 — the notification list and its read state — plus #86, per-subject muting. */

import type {
  NotificationFilter,
  NotificationMutesBody,
  NotificationMutesResponse,
  NotificationsReadAllResponse,
  NotificationsResponse,
  SubjectType,
} from '@lw/shared';
import { apiJson, apiVoid } from './client';

export type NotificationsParams = {
  filter?: NotificationFilter;
  cursor?: string;
  limit?: number;
};

/** #48 `GET /api/notifications` — keyset pagination via the opaque `cursor`. */
export function getNotifications(
  params: NotificationsParams = {},
  signal?: AbortSignal,
): Promise<NotificationsResponse> {
  return apiJson<NotificationsResponse>('/notifications', {
    query: { filter: params.filter, cursor: params.cursor, limit: params.limit },
    signal,
  });
}

/** #49 `POST /api/notifications/:id/read` — idempotent. */
export function markNotificationRead(id: number): Promise<void> {
  return apiVoid(`/notifications/${id}/read`, { method: 'POST' });
}

/** #50 `POST /api/notifications/read-all` — every unread notification of every type. */
export function markAllNotificationsRead(): Promise<NotificationsReadAllResponse> {
  return apiJson<NotificationsReadAllResponse>('/notifications/read-all', { method: 'POST' });
}

/**
 * #86 `PUT /api/notifications/targets/:t/:id` — the kebab "Notifications" checkboxes.
 *
 * An omitted key leaves that type untouched, so one click sends one key. Answers with the subject's
 * own block, which is what the row repaints from.
 */
export function putNotificationTarget(
  t: SubjectType,
  id: number,
  body: NotificationMutesBody,
): Promise<NotificationMutesResponse> {
  return apiJson<NotificationMutesResponse>(`/notifications/targets/${t}/${id}`, {
    method: 'PUT',
    body,
  });
}
